import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { Combobox } from '@/common/ui/combobox'
import { columns } from './constants'
import { GetDynamicSectionDataResponse } from '@/modules/client-setting/type'
import useQueryGetGameProviderList from '@/modules/game/api/hooks/useQueryGetGameProviderList'
import { useTablePagination } from '@/common/hooks/useTablePaginate'

interface DynamicSectionTableProps {
	data: GetDynamicSectionDataResponse[]
	isLoading?: boolean
	total: number
}

export default function DynamicSectionTable({
	data,
	isLoading,
	total,
}: DynamicSectionTableProps) {
	const { selectedQuery, setSelectedQuery } = useTablePagination()
	const { data: providerData } = useQueryGetGameProviderList({
		skip: 0,
		take: 500,
	})

	const providerOptions = [
		{
			label: 'ทั้งหมด',
			value: '',
		},
		...(providerData?.data.map((provider) => ({
			label: provider.name || '',
			value: provider.name,
		})) || []),
	]

	return (
		<div className="space-y-4">
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-2">
					<Combobox
						placeholder="เลือกค่ายเกม"
						options={providerOptions}
						value={selectedQuery}
						onValueChange={setSelectedQuery}
					/>
					<DataTableSearch placeHolder="ค้นหา Section" />
					<DataTableResetFilter />
				</div>
			</div>
			<DataTablePaginate
				columns={columns}
				data={data}
				isLoading={isLoading}
				totalItems={total}
			/>
		</div>
	)
}
